var map = {
	"./carrot.png": [
		1245,
		245
	],
	"./cucumber.png": [
		3016,
		16
	],
	"./lettuce.png": [
		1752,
		752
	],
	"./path.png": [
		3493,
		493
	],
	"./tomato.png": [
		3694,
		694
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7034;
module.exports = webpackAsyncContext;